export enum EIIPrintForm {
  MARKING_5 = 'Marking5',
  INTERNATIONAL_MARKING = 'International_Marking'
}

export enum EIIState {
  IEW = 'IEW',
  CLOSED = 'Closed',
  REQUEST = 'Request',
  UPDATED = 'Updated',
  VERIFIED = 'Verified',
  NOT_VERIFIED = 'NotVerified',
}
